import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { contentHeaders,APIURL,JsonURL } from '../common/headers';
import { IUsers } from '../database';
import { LoginService  } from '../service';

@Injectable()
export class QusAnsService {
     private _getQusAnsAllUrl = APIURL+'Question/getAllQuestion';
    private _getQusAnsUrl = APIURL+'Question/Question';
    private _isActivelUrl = APIURL+'Question/questionVerify';
    private _deleteUrl = APIURL+'Question/deleteQuestion';
    private _addUrl = APIURL+'Question/saveQuestion';
    //private _uploadUrl = APIURL+'Question/uploadQuestion';
    private _uploadUrl = APIURL+'Question/uploadQuestionExcel';
    private _getQusAnsBySearchUrl= APIURL+'Question/QuestionBySearch';
    private _editUrl = APIURL+'Question/updateQuestionById';
    private _getByIdUrl = APIURL+'Question/getQuestionById';
    private _getByprodecIdUrl= APIURL+'Question/getQuestionByprodecId';
    private currentUser :IUsers ; 
    constructor(private _http: Http) { 

    } 
    getQusByProdecId(prodecId){
         let formData:FormData = new FormData();
        formData.append('prodecId', prodecId);
        return this._http.post(this._getByprodecIdUrl,formData )
                            .map((response: Response) => response.json())
    }
    isQusAnsActive(SubjectId:string,type): any{
         let formData:FormData = new FormData();
         formData.append('QusAnsId', SubjectId);
          formData.append('type', type);
        return this._http.post(this._isActivelUrl,formData )
                            .map((response: Response) => response.json())
                            .catch(this.handleError);
    }
    getQusAnsById(QuestionID):any{
        let formData:FormData = new FormData();
        formData.append('QuestionID', QuestionID);
        return this._http.post(this._getByIdUrl,formData )
                            .map((response: Response) => response.json().data)
    }
    getAllQus(){
        return this._http.post(this._getQusAnsAllUrl,null )
                            .map((response: Response) => response.json().data)
    }
    getAllQusAnss(page,pageSize):any{
        let formData:FormData = new FormData();
         formData.append('page', page);
         formData.append('pageSize', pageSize);
        return this._http.post(this._getQusAnsAllUrl,formData )
                            .map((response: Response) => response.json())
    }
    getChapterAllByTextAndSize(search,pageNo,pageSize):any{
        let formData:FormData = new FormData();
         formData.append('search',search );
         formData.append('pageNo',pageNo );
         formData.append('pageSize',pageSize );
        return this._http.post(this._getQusAnsBySearchUrl,formData )
                            .map((response: Response) => response.json().data)
    }
    getChapterAllByIdTextAndSize(search,pageNo,pageSize):any{
        let formData:FormData = new FormData();
        var currentUser = JSON.parse(localStorage.getItem('UserInfo'));
         formData.append('userId', currentUser.UserId+"");
         formData.append('search',search );
         formData.append('pageNo',pageNo );
         formData.append('pageSize',pageSize );
        return this._http.post(this._getQusAnsBySearchUrl,formData )
                            .map((response: Response) => response.json().data)
    }
    getQus(userId:any): any{
         let formData:FormData = new FormData();
         formData.append('userId', userId);
        return this._http.post(this._getQusAnsUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    getQusAnss(userId:any,page,pageSize): any{
         let formData:FormData = new FormData();
         formData.append('userId', userId);
         formData.append('page', page);
         formData.append('pageSize', pageSize);
        return this._http.post(this._getQusAnsUrl,formData )
                            .map((response: Response) => response.json())
         
    }
    productAdd(form,qustionImg:File,ProductId){
        var currentUser = JSON.parse(localStorage.getItem('UserInfo'));
         let formData:FormData = new FormData();
           formData.append('QustionType', form[0].QustionType);
           formData.append('ProductId', ProductId);
           formData.append('ChapterId', form[0].ChapterId);
           formData.append('qustion', form[0].qustion);
           formData.append('Explanation', form[0].Explanation); 
            formData.append('userId', currentUser.UserId+"");
           formData.append('answers', JSON.stringify(form[0].answers));
         if(qustionImg!=null){
               formData.append('qustionImg', qustionImg,qustionImg.name);
          }
        return this._http.post(this._addUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    add(form:any,qustionImg:File):any{  
           let formData:FormData = new FormData();
           var currentUser = JSON.parse(localStorage.getItem('UserInfo'));
           formData.append('QustionType', form.QustionType);
           formData.append('ProductId', form.ProductId);
           formData.append('ChapterId', form.ChapterId);
           formData.append('qustion', form.qustion);
           formData.append('Explanation', form.Explanation); 
            formData.append('userId', currentUser.UserId+"");
           formData.append('answers', JSON.stringify(form.answers));
         if(qustionImg!=null){
               formData.append('qustionImg', qustionImg,qustionImg.name);
          }
        return this._http.post(this._addUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    edit(form:any,qustionImg:File):any{  
           let formData:FormData = new FormData();
           var currentUser = JSON.parse(localStorage.getItem('UserInfo'));
           formData.append('QustionType', form.QustionType);
           formData.append('ProductId', form.ProductId);
           formData.append('ChapterId', form.ChapterId);
           formData.append('qustion', form.qustion);
           formData.append('Explanation', form.Explanation); 
            formData.append('userId', currentUser.UserId+"");
           formData.append('answers', JSON.stringify(form.answers));
            formData.append('QuestionID', form.QuestionID);
            if(qustionImg!=null){
               formData.append('qustionImg', qustionImg,qustionImg.name);
          }
           
        return this._http.post(this._editUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    delete(QusId): any{
           let formData:FormData = new FormData();
         formData.append('QuestionId',QusId);
        return this._http.post(this._deleteUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    uploadQustionFile(file ,ProductId,img:any=null){
        let formData:FormData = new FormData();
        var currentUser = JSON.parse(localStorage.getItem('UserInfo'));
        formData.append('ProductId', ProductId);
        formData.append('qustionExcel', file,file.name);
        if(img!=null){
            formData.append('qustionImg', img,img.name);
        }
        formData.append('userId', currentUser.UserId+"");
        return this._http.post(this._uploadUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
     private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./src/app/service/qus-ans.service.ts